import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError(err => {
      if (err.status === 403 && err.error?.error === 'Session superseded. Please login again.') {
        alert('Session superseded. Please login again.');
        router.navigate(['/']);
        return throwError(() => 'Session superseded');
      }
      const error = err?.error?.message || err.statusText || 'Unexpected error';
      return throwError(() => error);
    })
  );
};
